export default {"src":"/_next/static/media/wallet-icon.ef37e671.svg","height":13,"width":15};